import React, { useState, useRef, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from 'axios';

// ICONOS
import { MdArrowBackIos, MdCreditCard, MdCheckCircle } from 'react-icons/md';
import useInput from "../hooks/useInput";
import Card from '../components/UI/Card';
import AuthContext from "../context/auth-context";
import { AppContext } from "../services/AppContext";
import useGetInfoPersonal from "../hooks/useGetInfoPersonal";
//import useGetPermitidoPagar from "../hooks/useGetPermitidoPagar";
import useGetFechaAdmision from "../hooks/useGetFechaAdmision";
import useGetFechaAdmisionElegida from "../hooks/useGetFechaAdmisionElegida";
import useGetModalidad from "../hooks/useGetModalidad";
import { MdEdit, MdSave,} from "react-icons/md";
import moment from 'moment'
import 'moment/locale/es';
import useGetALLFechaAdmision from "../hooks/useGetALLFechaAdmision";
import useGetFechaAdmisionFull from "../hooks/useGetFechaAdmisionFull";
import useGetMontoPago from "../hooks/useGetMontoPago";



/**************************************************************************/
//import useGetExperienciaLaboral from '../hooks/useGetExperienciaLaboral';
//import useGetRangoSalarial from '../hooks/useGetRangoSalarial';
//import useGetMonedaSalario from '../hooks/useGetMonedaSalario'

/*************************************************************************/


moment.locale('es');
var meses = 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_');
var semanas = 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_');
moment.updateLocale('es', { months : meses, weekdays : semanas });


const ProgramarAdmision = () => {

    const authContext = useContext(AuthContext);
    const { appValues, setAppValues } = useContext(AppContext);
    const infoPersonal = useGetInfoPersonal(authContext.token);

   // const fechasAdmisionArray  = useGetFechaAdmision();
    const fechasAdmisionAllArray  = useGetALLFechaAdmision(authContext.token);

    const fechasAdmisionFullArray  = useGetFechaAdmisionFull();

    const modalidadArray  = useGetModalidad();

    const montoUSD = useGetMontoPago();

    

    
    const [block, setBlock] = useState(false);
    const handleEditar = () => {
        setBlock(!block);
    }

    const [isUpdate, setIsUpdate] = useState(false);

    const fechaAdmisionElegidaData = useGetFechaAdmisionElegida(authContext.token);

    console.log(fechaAdmisionElegidaData);


    const navigate = useNavigate();

    


//    myDate.set({ date: 6, month: 3, year: 2020, hour: 8, minute: 30, second: 0 });

    /*myDate.format(); // devuelve el string '2020-04-06T05:30:00+02:00'
myDate.format('L'); // devuelve el string '04/06/2020'
myDate.format('LL'); // devuelve el string '6 de abril de 2020'
myDate.format('LLL'); // devuelve el string '6 de abril de 2020 5:30'*/

//console.log(myDate.format('LLLL'));
// devuelve el string 'lunes, 6 de abril de 2020 5:30'


//fechasAdmisionFullArray
const arreglo_fechas = fechasAdmisionFullArray.map(function(element){
    var momento = moment(element.FECHA_FULL, "DD/MM/YYYY HH:mm:ss");
    //hh:mm A,  console.log(moment(element.FECHA_FULL).format("hh:mm A"));
    return momento;
});


/*****************************************************************************************************/



/****************************************************************************************************************** */


    const fechaelegidaValidacion = value => value.trim() !== "";
    const {
        value: fechaelegida,
        isValid: fechaelegidaIsValid,
        isTouched: fechaelegidaIsTouched,
        userChange: fechaelegidaUserChange,
        divInput: divFechaelegida,
        valueChangeHandler: fechaelegidaChangeHanlder,
        inputBlurHandler: fechaelegidaBlurHandler,
        resetInput: resetInputFechaelegida,
        scrollToDiv: scrollToDivFechaelegida,
        setInputValue: setFechaelegidaValue
    } = useInput(fechaelegidaValidacion);

    useEffect(() => {
        if(!!fechaAdmisionElegidaData.fecha_admision_elegida && !fechaelegidaUserChange){
            setFechaelegidaValue(fechaAdmisionElegidaData.fecha_admision_elegida);
        }
    }, [fechaAdmisionElegidaData.fecha_admision_elegida, fechaelegidaUserChange, setFechaelegidaValue]);



    const modalidadelegidaValidacion = value => value.trim() !== "";
    const {
        value: modalidadelegida,
        isValid: modalidadelegidaIsValid,
        isTouched: modalidadelegidaIsTouched,
        userChange: modalidadelegidaUserChange,
        divInput: divModalidadelegida,
        valueChangeHandler: modalidadelegidaChangeHanlder,
        inputBlurHandler: modalidadelegidaBlurHandler,
        resetInput: resetInputModalidadelegida,
        scrollToDiv: scrollToDivModalidadelegida,
        setInputValue: setModalidadelegidaValue
    } = useInput(modalidadelegidaValidacion);

    useEffect(() => {
        if(!!fechaAdmisionElegidaData.modalidad_elegida && !modalidadelegidaUserChange){
            setModalidadelegidaValue(fechaAdmisionElegidaData.modalidad_elegida);
        }
    }, [fechaAdmisionElegidaData.modalidad_elegida, modalidadelegidaUserChange, setModalidadelegidaValue]);


    
    useEffect(() => {
        let flag = !!fechaAdmisionElegidaData.fecha_admision_elegida && fechaAdmisionElegidaData.fecha_admision_elegida !== ""
        if(flag){
            setBlock(true);
            setIsUpdate(true);
        }
    }, [fechaAdmisionElegidaData]);
    
    let formIsValid = false;


    if(fechaelegidaIsValid ||
        modalidadelegidaIsValid)
    {
        formIsValid = true;
    }


       // SUBMIT HANDLER
       const formSubmitHanlder = async(event) => {
        event.preventDefault();
        fechaelegidaBlurHandler();
        modalidadelegidaBlurHandler();

        if(!formIsValid){

            if(!fechaelegidaIsValid) {
                scrollToDivFechaelegida();
                return;
            }

            if(!modalidadelegidaIsValid) {
                scrollToDivModalidadelegida();
                return;
            }

        }

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('fechaAdmision', fechaelegida);
       // form_data.append('modalidad',1)
       form_data.append('modalidad', modalidadelegida);

       console.log(form_data);


        if(isUpdate)
        {
            form_data.append('updateFechaAdmision', 1);
        } else {
            form_data.append('saveFechaAdmision', 1);
        }

       // console.log(form_data);

        axios.post(process.env.REACT_APP_API_URL, form_data)
        .then(res => {
                
               /*setAppValues(
                    prev => {
                        let perfil = prev.datosPersonales ? prev.perfil : prev.perfil+25;
                        return { ...prev, datosPersonales: true, perfil };
                    }
                );
                */
               //Probalemente se necesite aquí actualizar el context global

               const result = res.data;

               console.log(result);


                //props.onCompletado('datos-personales');

                //Asumo que aqui es necesario mostrar un mensaje que diga, fecha programada exitosamente,
                // y que luego mande a home (con el estado actualizado)

                if( result.SUCCESS && result.SUCCESS===true){  //  result.SUCCESS==true result.MESSAGE){
                    Swal.fire({
                        icon: 'success',
                        title: result.MESSAGE,
                        showConfirmButton: false,
                        timer: 4000
                    });
                    //navigate('/pagos', { replace: true });
                setIsUpdate(true);
                handleEditar();
                navigate('/', { replace: true });
                } 
                else{

                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrió un problema, intentelo más tarde',
                        showConfirmButton: false,
                        timer: 3500
                    });

                }



            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });

            })


    }



    useEffect(() => {
  

        if
        (
            fechaAdmisionElegidaData !== undefined && "fecha_admision_elegida" in fechaAdmisionElegidaData && fechaAdmisionElegidaData.fecha_admision_elegida !== ""
        )
        {
            
            setAppValues(
                prev => {
                    return { ...prev, examenAplicante: true};
                }
            );
        }else {
            setAppValues(
                prev => {
                    return { ...prev, examenAplicante: false};
                } 
            );
        }
    }, [
        fechaAdmisionElegidaData, setAppValues
    ]);


    
    return (
        <>
                    <div className="row">

            <div className="row py-5">
                <div className="col-lg-8 offset-lg-2 mt-2">
                    {/* BUTTON REGRESAR */}
                    <Link className="btn btn-outline-light border border-2 border-light shadow" style={{fontWeight: "500"}} to='/'>
                        <MdArrowBackIos/> Regresar
                    </Link>
                    &nbsp;
               
                </div>
            </div>

                <div className="col-lg-8 offset-lg-2">
                    <Card>
                        <div className="card-body">

                            <form className="row mt-4 mb-4" onSubmit={formSubmitHanlder}>
                                
                                {/* FECHA EXAMEN DE ADMISIÓN */}
                                <div className="col-md-10 offset-md-1">
                                    <h1 className="display-6 text-center text-secondary" style={{fontSize: '1.75rem', userSelect: 'none'}}>
                                        Fecha para examen de admisión
                                    </h1>
                                    <div className="text-danger pb-3"><hr /></div>
                                </div>




                <div className="col-md-12 d-flex justify-content-around">

{/* FECHA */}
<div className="col-md-6 mb-3" ref={divFechaelegida}>
    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='fecha'>
        ¿En qué fecha desea realizar su examen de admisión?
    </label>

    <select 
        className={`form-select form-select-sm shadow-sm ${fechaelegidaIsTouched ? ((fechaelegidaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
        name='fecha' 
        value={fechaelegida} 
        onChange={fechaelegidaChangeHanlder}
        onBlur={fechaelegidaBlurHandler}
        disabled={block ? true : false} 
        autoComplete='off'
        //style={{ width: '80%' }} // '200px'

    >
        <option value="">Seleccionar fecha</option>
        {fechasAdmisionAllArray.map(fechasadmision => (
            <option key={fechasadmision.ID_FECHA} value={fechasadmision.ID_FECHA}>{fechasadmision.FECHA}</option>
        ))}
    </select>
    <div className="invalid-feedback" style={{userSelect: 'none'}}>
        Campo obligatorio
    </div>
</div>

{/* MODALIDAD */}
<div className="col-md-5 mb-3" ref={divModalidadelegida}>
    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='modalidad'>
        ¿En qué modalidad desea realizar su examen?
    </label>

    <select 
        className={`form-select form-select-sm shadow-sm ${modalidadelegidaIsTouched ? ((modalidadelegidaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
        name='modalidad' 
        value={modalidadelegida} 
        onChange={modalidadelegidaChangeHanlder}
        onBlur={modalidadelegidaBlurHandler}
        disabled={block ? true : false} 
        autoComplete='off'
    >
        <option value="">Seleccionar modalidad</option>
        {modalidadArray.map(modalidad => (
            <option key={modalidad.APLICANTE_POSGRADO_NEG_MODALIDAD} value={modalidad.APLICANTE_POSGRADO_NEG_MODALIDAD}>{modalidad.DESCRIPCION}</option>
        ))}
    </select>
    <div className="invalid-feedback" style={{userSelect: 'none'}}>
        Campo obligatorio
    </div>
</div>

</div>









{/**/}



<div className="col-md-10 offset-md-1" style={{ userSelect: 'none', textAlign: 'justify' }}>
                                    <p className="text-black-50 fst-italic"></p>
                                </div>



                                <div className="col-md-10 offset-md-1" style={{ userSelect: 'none', textAlign: 'justify' }}>
                                    <p className="text-black-50 fst-italic">Para el programa "{infoPersonal.programa}" deberá pagar ${montoUSD} para realizar su prueba de admisión.
{/*TODO: Este monto será abonado a su primera cuota del programa, una vez sea admitido como estudiante.</p>
*/ }
</p>
                                </div>



                                <br></br>

                                <div className="col-md-10 offset-md-1" style={{ userSelect: 'none', textAlign: 'justify' }}>
                                    <p className="text-black-50 fst-italic">Si usted desea tomar el examen de admisión en <strong>Guatemala</strong>, entonces puede escoger una de las siguientes fechas:</p>

                                    <ul className="text-black-50 fst-italic">{arreglo_fechas.map(fechasadmision => (
                                        <li key={fechasadmision.format('LLL')} > {moment.weekdays(fechasadmision.day())} {fechasadmision.format('LL')} a partir de las {fechasadmision.format('hh:mm A')} </li> 
                                    ))}
                                    </ul>
                                </div>



                              {/*
                                <div className="col-md-10 offset-md-1" style={{ userSelect: 'none', textAlign: 'justify' }}>
                                    <p className="text-black-50 fst-italic">Se estará enviando el link, vía correo electrónico, para realizar el examen en la fecha elegida.</p>
                                </div>

                                            {moment.weekdays(fechasadmision.day())} {fechasadmision.format('LL')} a partir de las {fechasadmision.format('HH:mm a')}
                                            fechasadmision.format('HH:mm')
                                
                                            hh:mm a

                              */}


                                







                                       {/* EDITAR/GUARDAR */}
                                       <div className="col-md-10 offset-md-1 mt-3" style={{ textAlign: 'right' }}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            disabled={block} 
                                            type="submit">
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>
                       
                           

                            </form>

                        </div>
                    </Card>
                </div>
                </div>

        </>
    );
};

export default ProgramarAdmision;